import React, { useState } from "react";
import {
  Button,
  Divider,
  Grid,
  Modal,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import admission from "../assets/logo.png";
import axios from "axios";

const AutoPopUp = ({ isOpen, onClose }) => {
  const mobileScreen = useMediaQuery("(min-width: 360px) and (max-width: 599px)");
  const laptopScreen = useMediaQuery("(min-width: 1200px) and (max-width: 1440px)");

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [nameError, setNameError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const validateName = (value) => {
    if (!/^[A-Za-z\s]+$/.test(value) || value.length < 3) {
      setNameError("Enter a valid name");
      return false;
    }
    setNameError("");
    return true;
  };

  const validatePhone = (value) => {
    if (!/^\d{10}$/.test(value)) {
      setPhoneError("Enter a valid 10-digit phone number");
      return false;
    }
    setPhoneError("");
    return true;
  };

  const handleSubmit = async () => {
    if (!validateName(name) || !validatePhone(phone)) return;

    const requestData = {
      name,
      phone,
      leadType: "AakashYelahanka",
      leadFlag: "Paid",
    };

    try {
      const response = await axios.post(
        "https://gmc.getmycollege.com/university/addExternalSourceLead",
        requestData,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response?.status >= 200 && response?.status < 300) {
        setName("");
        setPhone("");
        sessionStorage.setItem("isFormSubmited", true);
        onClose(); // Close modal only after successful submission
        alert("Thank You!");
      } else {
        alert("Failed to add lead");
      }
    } catch (error) {
      alert("Something went wrong. Please try again later.");
      console.error(error);
    }
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
    validateName(value);
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setPhone(value);
    validatePhone(value);
  };

  return (
    <Modal open={isOpen} onClose={() => { }}>
      <Grid
        container
        xs={12}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "#ffffff",
          borderRadius: 1,
          width: { xs: "350px", md: "400px" },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          px: laptopScreen ? 2 : 4,
          py: mobileScreen ? 2 : laptopScreen ? 4 : 0,
        }}
      >
        <img src={admission} alt="admissionbanner" style={{ width: "180px", height: "120px", objectFit: "fill" }} />
        <Typography variant="h3" sx={{ fontSize: mobileScreen ? 20 : laptopScreen ? 25 : 28, fontWeight: 600, pt: 1 }}>
          Admission Enquiry
        </Typography>
        <Divider sx={{ background: "#2E65AD", width: 150, my: 2 }} />
        <Grid sx={{ display: "flex", alignItems: "center", justifyContent: "center", py: mobileScreen ? 2 : laptopScreen ? 3 : 4 }}>
          <Grid container spacing={mobileScreen ? 1.5 : 3}>
            <Grid item md={12} xs={12}>
              <TextField
                fullWidth
                placeholder="Enter Your Name"
                value={name}
                onChange={handleNameChange}
                error={!!nameError}
                helperText={nameError}
                inputProps={{ style: { fontSize: mobileScreen ? 12 : laptopScreen ? 10 : 13, background: "#ffff" } }}
                variant="outlined"
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                fullWidth
                placeholder="Enter Your Ph.No"
                value={phone}
                onChange={handlePhoneChange}
                error={!!phoneError}
                helperText={phoneError}
                inputProps={{ maxLength: 10, style: { fontSize: mobileScreen ? 12 : laptopScreen ? 10 : 13, background: "#fff" } }}
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleSubmit}
                sx={{
                  height: mobileScreen ? 30 : laptopScreen ? 40 : 40,
                  fontWeight: 600,
                  borderRadius: 0,
                  background: "#1d67ab",
                  "&:hover": { background: "#1d67ab" },
                  fontSize: mobileScreen ? 14 : laptopScreen ? 14 : 15,
                }}
              >
                Apply Now
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default AutoPopUp;